"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectItemStyled = exports.SelectStyled = exports.SelectWithHiddenArrow = exports.SelectWrapper = exports.SelectContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
exports.SelectContainer = styled_components_1.default.div `
    background-color: ${Color_enum_1.Color.Surface};
    border-radius: ${({ open }) => (open ? '10px 10px 0 0' : '10px')};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    border: 1px solid ${Color_enum_1.Color.Variant_1};
    padding: 0 24px;
    height: 64px;
    justify-content: center;
    position: relative;
    cursor: pointer;
    z-index: 99;
`;
exports.SelectWrapper = styled_components_1.default.label `
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;
exports.SelectWithHiddenArrow = styled_components_1.default.select `
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: transparent;
    border: none;
    color: ${Color_enum_1.Color.Primary};
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.25rem;
    letter-spacing: 0.047rem;
    outline: none;
    width: 100%;
    pointer-events: none;
`;
exports.SelectStyled = styled_components_1.default.div `
    top: 100%;
    left: 0;
    width: calc(100% + 2px);
    max-height: 200px;
    height: auto;
    z-index: 99;

    overflow: auto;
    position: absolute;
    color: ${Color_enum_1.Color.Secondary};
    background-color: ${Color_enum_1.Color.Surface};
    border-radius: 0 0 10px 10px;
    margin: 0 -1px;

    border: 1px solid ${Color_enum_1.Color.Variant_1};
`;
exports.SelectItemStyled = styled_components_1.default.div `
    padding: 4px 24px;
    color: ${Color_enum_1.Color.Secondary};
    &:hover {
        color: ${Color_enum_1.Color.Primary};
    }
`;
